module.exports = "/_next/static/images/5bec925b27ddb6aa071a43f804947a6b-pj-man-in-denim-jacket@md.jpg.webp";